import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'
import { StatusCount } from '../types/insights'

export function usePacketsByStatus(year?: string) {
  return useQuery({
    queryKey: ['insights', 'packets-by-status', year],
    queryFn: async () => {
      const params = year ? { year } : undefined
      const response = await get<{ data: StatusCount[] }>('/insights/packets-by-status', params)
      return response.data
    },
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 2, // 2 hours
  })
} 